// src/utils/mediaUtils.js
const getMediaUrl = (appName, relativePath) => {
  if (!relativePath) return null;

  // If it's already a full URL, return as is
  if (relativePath.startsWith('http://') || relativePath.startsWith('https://')) {
    return relativePath;
  }

  // Get the API base URL and construct media URL
  const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  // Remove leading slash if present to avoid double slashes
  const cleanPath = relativePath.startsWith('/') ? relativePath.slice(1) : relativePath;

  return `${API_BASE}/${appName}/${cleanPath}`;
};

/**
 * Append a cache-busting query param to a media path, derived from `version`
 * (e.g. a job's user_modifications_saved_at timestamp). Needed because files
 * like rotated_image/rotated_thumbnail keep a stable, deterministic name on
 * disk across regenerations, so the URL itself wouldn't otherwise change when
 * the underlying file is regenerated — and both the browser HTTP cache
 * (Cache-Control: max-age=3600) and useImageWithAuth's own loadedUrls cache
 * key strictly on the path string.
 */
const withCacheBust = (relativePath, version) => {
  if (!relativePath || !version) return relativePath;
  const separator = relativePath.includes('?') ? '&' : '?';
  return `${relativePath}${separator}v=${encodeURIComponent(version)}`;
};

export { getMediaUrl, withCacheBust };